import type { AccountInfo } from '@azure/msal-browser';

/** Derive initials from display name, falling back to email local-part when name is absent. */
export function getInitials(displayName: string, emailFallback = ''): string {
  const trimmedName = (displayName || '').trim();
  if (trimmedName) {
    const parts = trimmedName.split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return trimmedName.slice(0, 2).toUpperCase();
  }

  const email = (emailFallback || '').trim();
  if (!email) return '?';

  const local = email.includes('@') ? email.split('@')[0] : email;
  const segments = local.split(/[._-]+/).filter(Boolean);
  if (segments.length >= 2) {
    return (segments[0][0] + segments[segments.length - 1][0]).toUpperCase();
  }
  return local.slice(0, 2).toUpperCase();
}

/** Resolve sign-in email from MSAL account claims or username. */
export function getAccountEmail(user: AccountInfo | null | undefined): string {
  if (!user) return '';
  const claims = user.idTokenClaims as Record<string, unknown> | undefined;
  const fromClaims = claims?.email ?? claims?.preferred_username;
  if (typeof fromClaims === 'string' && fromClaims.trim()) {
    return fromClaims.trim();
  }
  return (user.username || '').trim();
}
